import api from '../index'

export interface CopybookTemplateItem {
  id: number
  name: string
  status: boolean
  cover_image?: string | null
  config?: Record<string, any> | null
}

export interface CopybookTemplateListParams {
  page?: number
  limit?: number
  search?: {
    name?: string
  }
}

export interface CopybookTemplateFormData {
  id?: number
  name: string
  status: boolean
  cover_image?: string | null
  config?: Record<string, any> | null
}

export interface CopybookTemplateOption {
  label: string
  value: number
}

export default {
  getCopybookTemplateList: (params: CopybookTemplateListParams = {}): Promise<{ data: { list: CopybookTemplateItem[], total: number, limit: number } }> => {
    return api.get('/CopybookTemplate/getCopybookTemplateList', { params })
  },

  getCopybookTemplateOptions: (): Promise<{ data: CopybookTemplateOption[] }> => {
    return api.get('/CopybookTemplate/getCopybookTemplateOptions')
  },

  createCopybookTemplate: (data: CopybookTemplateFormData): Promise<{ data: CopybookTemplateItem }> => {
    return api.post('/CopybookTemplate/createCopybookTemplate', data)
  },

  getCopybookTemplateDetail: (id: number): Promise<{ data: CopybookTemplateItem }> => {
    return api.get('/CopybookTemplate/getCopybookTemplateDetail', { params: { id } })
  },

  updateCopybookTemplate: (data: CopybookTemplateFormData): Promise<{ data: CopybookTemplateItem }> => {
    return api.post('/CopybookTemplate/updateCopybookTemplate', data)
  },

  deleteCopybookTemplate: (id: number): Promise<{ data: any }> => {
    return api.post('/CopybookTemplate/deleteCopybookTemplate', { id })
  },
}
